import Model    from "../core/Model";
import Sector   from "./Sector";
import User     from "./User";
import City     from "./City";
import Event    from "./Event";
import Area     from "./Area";
import Budget   from "./Budget";
import Supplier from "./Supplier";

export default class Rq extends Model{

    constructor( options = {} ) {

        super(null);

        this.setOptions(options);
    }

    setOptions( options = {} )
    {
        this.id                 = options.id                || null;
        this.description        = options.description       || null;
        this.hasDesign          = options.hasDesign         || 0;
        this.accept             = options.accept            || 0;
        this.files              = options.files             || {};
        this.origin             = options.origin            || {};
        this.sector             = options.sector            || new Sector(   options.sector     || {'id' : 172, 'name' :  'Stands'} );
        this.user               = options.user              || new User(     options.user       || {} );
        this.city               = options.city              || new City(     options.city       || {} );
        this.event              = options.event             || new Event(    options.event      || {} );
        this.area               = options.area              || new Area(     options.area       || {} );
        this.budget             = options.budget            || new Budget(   options.budget     || {} );
        this.supplier           = options.supplier          || new Supplier( options.supplier   || {} );
        this.locale             = options.locale            || 'en';
        this.properties         = options.properties        || [];
        this.has_design         = options.has_design;
        this.deadLineRelative   = options.deadLineRelative;
    }

    toJson ()
    {
        return {
            id               : this.id,
            sector           : this.sector,
            description      : this.description,
            has_design       : this.has_design,
            accept           : this.accept,
            origin           : this.origin,
            locale           : this.locale,
            deadLineRelative : this.deadLineRelative,
            files            : this.files,
            user             : this.user        ? this.user.toJson()     : null,
            city             : this.city        ? this.city.toJson()     : null,
            event            : this.event       ? this.event.toJson()    : null,
            area             : this.area        ? this.area.toJson()     : null,
            budget           : this.budget      ? this.budget.toJson()   : null,
            supplier         : this.supplier    ? this.supplier.toJson() : null,
        }
    }
}




// WEBPACK FOOTER //
// ./resources/js/models/Rq.js